import { cssVar } from './cssVar'

export const colorTokens = {
  primary: cssVar('--app-primary'),
  focus: cssVar('--app-color-focus'),
  status: {
    error: cssVar('--app-color-error'),
    success: cssVar('--app-color-success'),
    warning: cssVar('--app-color-warning'),
    info: cssVar('--app-color-info'),
  },
  text: {
    primary: cssVar('--app-text-primary'),
    secondary: cssVar('--app-text-secondary'),
    disabled: cssVar('--app-text-disabled'),
    muted: cssVar('--app-text-muted'),
    title: cssVar('--app-toolkit-title'),
    description: cssVar('--app-toolkit-description'),
  },
  surface: {
    panel: cssVar('--app-bg-panel'),
    hover: cssVar('--app-bg-hover'),
    active: cssVar('--app-bg-active'),
    borderLight: cssVar('--app-border-light'),
    leftNav: cssVar('--app-left-nav-bg'),
  },
  toolkit: {
    panelBg: cssVar('--app-toolkit-panel-bg'),
    panelBorder: cssVar('--app-toolkit-panel-border'),
  },
}
